import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ShoppingCart, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { useCartCount } from "@/store/cart";

const NAV = [
  { to: "/location", label: "Location" },
  { to: "/shop", label: "Shop" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export function Header() {
  const count = useCartCount();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    // Le header est transparent sur le hero puis se densifie : le seuil evite
    // qu il clignote au moindre mouvement de trackpad.
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={cn(
        "fixed inset-x-0 top-0 z-50 flex items-center justify-between px-6 py-5 transition-colors duration-300 md:px-10",
        scrolled
          ? "border-b border-hairline bg-night/70 backdrop-blur-lg"
          : "border-b border-transparent",
      )}
    >
      <Link to="/" className="wordmark text-[22px] leading-none" aria-label="Lumosphere, accueil">
        LUMOSPHERE
      </Link>

      <nav className="hidden items-center gap-9 md:flex">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                "text-[14.5px] transition-colors",
                isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground",
              )
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="flex items-center gap-3">
        <Link
          to="/panier"
          className="relative flex size-[38px] items-center justify-center rounded-full border border-hairline text-muted-foreground transition-colors hover:border-brand hover:text-brand"
          aria-label={count > 0 ? `Panier, ${count} article(s)` : "Panier, vide"}
        >
          <ShoppingCart className="size-4" />
          {count > 0 && (
            <span className="absolute -right-1 -top-1 flex size-[18px] items-center justify-center rounded-full bg-brand text-[10px] font-semibold text-primary-foreground">
              {count}
            </span>
          )}
        </Link>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex size-[38px] items-center justify-center rounded-full border border-hairline text-muted-foreground md:hidden"
          aria-label={menuOpen ? "Fermer le menu" : "Ouvrir le menu"}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <X className="size-4" /> : <Menu className="size-4" />}
        </button>
      </div>

      {menuOpen && (
        <div className="absolute inset-x-0 top-full border-b border-hairline bg-night/95 backdrop-blur-lg md:hidden">
          <nav className="flex flex-col px-6 py-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className="border-b border-hairline py-4 text-base last:border-0"
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
